<template>
  <div class="page-template__sidebar-right">
    <h1 class="main-heading">
      <translation en="Month overview" ch="月份概览"></translation>
    </h1>
    <div class="content-section">
      <div class="content-section__left">

        <div class="home-tiles__overview">
          <div class="home-tiles__overview-tile">
            <div class="home-tiles__overview-tile--left">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="0.7">
                <path d="M3 20V4M3 20H21" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="5" y="14" width="2" height="6" rx="0.5"/>
                <rect x="9" y="10" width="2" height="10" rx="0.5"/>
                <rect x="13" y="6" width="2" height="14" rx="0.5"/>
                <path d="M17 12L20 9L23 12" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20 9V20" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>


            <div class="home-tiles__overview-tile--right">
              <span class="value">
                <counter prefix="" duration="600" type="int" :targetCount="sales" />
              </span>
              <span class="label">Sales this month
                <div v-if="reportSummary.trend && reportSummary.trend.sales_trend">
                  <span class="trend" v-bind:class = "(reportSummary.trend.sales_trend_type === 'decrease') ? 'red' : 'green'">{{ reportSummary.trend.sales_trend }}%</span>
                </div>
              </span>
            </div>
          </div>
          <div class="home-tiles__overview-tile">
            <div class="home-tiles__overview-tile--left">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="feather feather-activity"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
            </div>
            <div class="home-tiles__overview-tile--right">
              <span class="value">
                <counter prefix="" duration="600" type="int" :targetCount="campaigns_joined" />
              </span>
              <span class="label">Campaigns joined
                <router-link to="/campaigns/my-campaigns">
                  My campaigns
                </router-link>
              </span>
            </div>
          </div>
          <div class="home-tiles__overview-tile">
            <div class="home-tiles__overview-tile--left">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
            </div>
            <div class="home-tiles__overview-tile--right">
              <span class="value">
                <counter prefix="$" duration="1200" type="decimal" :targetCount="earnings" />
              </span>
              <span class="label"><translation en="Estimated earnings" ch="收益"></translation>
                <div v-if="reportSummary.trend">
                  <span v-if="reportSummary.trend.commission_trend !== 0" class="trend" v-bind:class = "(reportSummary.trend.commission_trend_type === 'decrease') ? 'red' : 'green'">{{ reportSummary.trend.commission_trend }}%</span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="home-tiles__main">
          <div class="card">
            <h2 class="card__heading graph icon">
              <translation en="Sales performance this month" ch="本月销售业绩"></translation>
            </h2>
            <div class="performance-graph" v-bind:class = "(reportSummary.data && reportSummary.data.length < 1 && !loadingGraph) ? 'empty' : ''">
              <loading :loading="loadingGraph" size="component"></loading>
              <graph v-if="!loadingGraph && reportSummary.labels.length > 0" data_type="sales" :data_labels="reportSummary.labels" :data_input="reportSummary.data"></graph>
            </div>
          </div>
          <div class="card">
            <h2 class="card__heading top-campaigns icon">
              <translation en="Top 3 campaigns" ch="排名前 3 的营销活动"></translation>
            </h2>
            <div class="card__content">
              <loading size="component" :loading="loadingTopCampaigns"></loading>

              <carousel v-if="!loadingRecommendedCampaigns"
                  :items-to-show="1"
                  :autoplay="6000"
                  :wrap-around="true"
                  :breakpoints="{
                    640: { itemsToShow: 3 } // Show 1 item for screens smaller than 640px
                  }"
              >
              <slide v-for="campaign in topCampaigns" :key="campaign">
                  <SmallCampaignCard :campaign="campaign" />
                </slide>
               
                <template #addons>
                  <navigation />

                </template>

              </carousel>

            </div>
          </div>
          <div class="card">
            <h2 class="card__heading recommended icon">
              <translation en="Recommended for you" ch="为你推荐"></translation>
            </h2>
            <div class="card__content">
              <loading size="component" :loading="loadingRecommendedCampaigns"></loading>

              <carousel v-if="!loadingRecommendedCampaigns"
                  :items-to-show="1"
                  :autoplay="6000"
                  :wrap-around="true"
                  :breakpoints="{
                    640: { itemsToShow: 3 } // Show 1 item for screens smaller than 640px
                  }"
              >
                <slide v-for="campaign in recommendedCampaigns" :key="campaign">
                  <SmallCampaignCard :campaign="campaign" />
                </slide>

                <template #addons>
                  <navigation />

                </template>

              </carousel>

            </div>
          </div>
        </div>
      </div>
      <div class="content-section__right">
        <TrendingMerchants />
      </div>
    </div>
  </div>
</template>

<script>

import CampaignCard from "@/components/CampaignCard.vue";
import Counter from "@/components/Counter.vue";
import SmallCampaignCard from "@/components/SmallCampaignCard.vue";
import TrendingMerchants from "@/components/TrendingMerchants.vue";
import Loading from './../components/Loading.vue';
import axios from 'axios';

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import store, {useStore} from '../store';
import Graph from "@/components/Graph.vue";
import Translation from "@/components/Translation.vue";
import { RouterLink } from "vue-router";

export default {
  name: 'HomeView',
  components: {
    Translation,
    Graph,
    CampaignCard,
    SmallCampaignCard,
    TrendingMerchants,
    Counter,
    Loading,
    Carousel,
    Slide,
    Pagination,
    Navigation,
    RouterLink
},
  watch: {
    targetCount() {
      this.startCounting();
    },
  },
  data() {
    return {
      campaigns_joined: 0,
      earnings: 0.00,
      currentCount: 0,
      sales: 0,
      targetCount: 100, // Change this to your desired target count
      duration: 3000,
      reportSummary: {},
      recommendedCampaigns: [],
      topCampaigns: [],
      loadingTopCampaigns: true,
      loadingRecommendedCampaigns: true,
      loadingGraph: true,
    }
  },
  methods: {

    get_user_data(){
      if(this.$getSessionToken()) {
        axios.get('https://apis.topstylemedia.com/index.php/wp-json/v1/user-data',
            {
              headers: {
                'Authorization': `Bearer ${this.$getSessionToken()}`,
              }
            }
        ).then(response => {
          const store = useStore();
          store.user_data = response.data;
          this.user_data = store.user_data;
          this.campaigns_joined = response.data.campaigns_joined;
          this.loggedIn = true;
        }).catch(error => {
          this.$unauthorisedEndpoint();
        });
      }
    },

    startCounting() {
      const start = Date.now();
      const updateCount = () => {
        const elapsed = Date.now() - start;
        if (elapsed < this.duration) {
          this.currentCount = Math.ceil(
              (this.targetCount * elapsed) / this.duration
          );
          requestAnimationFrame(updateCount);
        } else {
          this.currentCount = this.targetCount;
        }
      };
      requestAnimationFrame(updateCount);
    },

    async fetchGraphData() {

      try {
        const requestBody = {
          format: 'current_month',
          type: 'sales',
          merchant_id: undefined // Assuming you want to send undefined as a value
        };

        const response = await axios.post(
            'https://apis.topstylemedia.com/index.php/wp-json/v1/get-tsm-summary',
            requestBody,
            {
              headers: {
                'Authorization': `Bearer ${this.$getSessionToken()}`
              }
            }
        );

        this.reportSummary.labels = response.data.sales.labels;
        this.reportSummary.data = response.data.sales.data;
        this.reportSummary.trend = response.data;
        this.earnings = response.data.total_commission;
        this.sales = response.data.total_sales;
      } catch (error) {
        //this.$unauthorisedEndpoint();
      } finally {
        this.loadingGraph = false;
      }
    },

    async fetchTopCampaigns() {

      try {
        const response = await axios.get('https://apis.topstylemedia.com/index.php/wp-json/v1/top-campaigns',
        {
          headers: {
            'Authorization': `Bearer ${this.$getSessionToken()}`,
          }
        });
        this.topCampaigns = response.data;
      } catch (error) {
        this.$unauthorisedEndpoint();
      } finally {
        this.loadingTopCampaigns = false;
      }
    },

    async fetchRecommendedCampaigns() {

      try {
        const response = await axios.get('https://apis.topstylemedia.com/index.php/wp-json/v1/recommended-campaigns',
            {
              headers: {
                'Authorization': `Bearer ${this.$getSessionToken()}`,
              }
            }
        );
        this.recommendedCampaigns = response.data;
      } catch (error) {
        this.$unauthorisedEndpoint();
      } finally {
        this.loadingRecommendedCampaigns = false;
      }
    }


  },
  async mounted() {
    try {
      await this.get_user_data();
      this.startCounting();
      this.loadingGraph = true;
      await this.fetchGraphData();
      await this.fetchTopCampaigns();
      await this.fetchRecommendedCampaigns();
    } catch (error) {
      console.error('An error occurred:', error);
    }

  }
}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";


  .campaign-grid{
    width: 100%;
    display: flex;
    grid-gap: 2rem;
    justify-content: space-between;
    grid-template-columns: repeat(3, 1fr);
    @include bp(sm){
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
    .campaign-grid--card {
      flex: 1;
    }
  }
</style>
